/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { FC } from "react";
import useColors from "src/hooks/personalization/useColors";
import { useFormatMsg } from "src/hooks/useFormatMsg";
import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";

const btnStyles = css`
  margin-left: 0.5rem;
  width: 40px;
`;

type VisiblityButtonProps = PurposedButtonProps & {
  hasFilters?: boolean;
};

const VisibilityButton: FC<VisiblityButtonProps> = ({
  hasFilters,
  ...props
}) => {
  const { primaryColor } = useColors();
  const formatMsg = useFormatMsg();
  return (
    <EwaButton2
      data-cy="visibility-button"
      iconName="visibility"
      buttonColor={hasFilters ? primaryColor : "lightgray"}
      tooltip={formatMsg("template_builder.settings.filters")}
      css={btnStyles}
      {...props}
    />
  );
};

export default VisibilityButton;
